import React, { useEffect, useState } from 'react';
import { BsCurrencyDollar } from 'react-icons/bs';
import { GoPrimitiveDot } from 'react-icons/go';
import { IoIosMore } from 'react-icons/io';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Header, Stacked, Pie, Button, LineChart, SparkLine } from '../components';
import { earningData, medicalproBranding, recentTransactions, weeklyStats, dropdownData, SparklineAreaData, ecomPieChartData } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import product9 from '../data/product9.jpg';
import PhoneNumberInput from '../components/PhoneNumberInput';
import { useLocation, useNavigate } from "react-router-dom";
import VideoTestInfo from '../data/mainvideo.mp4';
import Swal from 'sweetalert2';

const NoticeTestInfo = () => {
  const { currentColor, currentMode } = useStateContext();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');

  // 전화번호 포맷팅 함수
  const formatPhoneNumber = (value) => {
    // 숫자만 남기기
    const cleaned = value.replace(/\D/g, '');

    // 포맷팅: 010-1234-5678
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 7) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7, 11)}`;
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(formatPhoneNumber(value));
  };

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);
  }, []);

  // 입력 완료 버튼 클릭 핸들러
  const saveUserId = () => {
    if (phoneNumber) {
      setUserId(phoneNumber); // 입력된 번호를 userId에 저장
      localStorage.setItem('userId', phoneNumber);
      Swal.fire({
        title: '사용자 등록완료',
        html : `휴대폰번호 : ${phoneNumber}`,
        icon: 'info',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
      });
    } else {
      Swal.fire({
        title: '사용자 등록실패',
        html : `휴대폰번호를 정확히 입력해 주세요`,
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
      });
    }
  };

  return (
    <div className="m-2 md:m-10 mt-0 p-2 md:p-10 bg-white rounded-3xl">

      <Header title="베타테스트 관련 안내" />
      {/* 상단 컴포넌트 그룹 */}
      <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
        {/* <p className="text-xl font-semibold">테스트 안내 영상</p><br /> */}
        <video
          width="100%"
          height="100%"
          autoPlay
          muted
          loop // 무한 반복 재생
        >
          <source src={VideoTestInfo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
        <p className="text-xl font-semibold">테스트 안내 문구</p>
        <p className="text-s">테스트 안내 문구테스트 안내 문구테스트 안내 문구테스트 안내 문구테스트 안내 문구테스트 안내 문구테스트 안내 문구테스트 안내 문구테스트 안내 문구테스트 안내 문구</p>
      </div> */}

      {
        userId
          ?
          <div className="flex justify-center">
            <Button
              color="white"
              bgColor={currentColor}
              text="데이터 탐색 시작하기"
              borderRadius="10px"
              onClick={() => navigate('/eda')}
            />
          </div>
          :
          <div className="bg-white p-8 rounded-3xl shadow-lg mb-12">
            <div className="flex gap-5">
              <div>
                <label htmlFor="phoneNumber" className="text-xl font-semibold">
                  참가자 확인을 위한 휴대폰 번호를 입력해 주세요.
                </label>
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="010-1234-5678"
                  value={phoneNumber}
                  onChange={handleInputChange}
                  className="mt-1 block w-[100%] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  maxLength={13} // 최대 길이 제한 (010-1234-5678)
                />
              </div>
              <Button
                color="white"
                bgColor={currentColor}
                text="입력완료"
                borderRadius="10px"
                onClick={saveUserId}
              />
            </div>
          </div>
      }
    </div>
  );
};

export default NoticeTestInfo;